const CHILLNN_PINK = "#F5778D";

/**
 *
 * @todo 後に Figma でデザインシステムとしてまとめる
 */
export const COLORS = {
	CHILLNN_PINK: {
		50: "#FEF2F3",
		100: "#FEE5E8",
		200: "#FCCFD6",
		300: "#F9A8B4",
		400: CHILLNN_PINK,
		500: "#EC4768",
		600: "#D82652",
		700: "#B71945",
		800: "#991840",
		900: "#83183C",
		950: "#49081C",
	},
	WHITE: {
		50: "rgba(255, 255, 255, 0.05)",
		100: "rgba(255, 255, 255, 0.1)",
		200: "rgba(255, 255, 255, 0.2)",
		300: "rgba(255, 255, 255, 0.3)",
		400: "rgba(255, 255, 255, 0.4)",
		500: "rgba(255, 255, 255, 0.5)",
		600: "rgba(255, 255, 255, 0.6)",
		700: "rgba(255, 255, 255, 0.7)",
		800: "rgba(255, 255, 255, 0.8)",
		900: "rgba(255, 255, 255, 0.9)",
		950: "rgba(255, 255, 255, 1.0)",
	},
	BLACK: {
		50: "rgba(0, 0, 0, 0.05)",
		100: "rgba(0, 0, 0, 0.1)",
		200: "rgba(0, 0, 0, 0.2)",
		300: "rgba(0, 0, 0, 0.3)",
		400: "rgba(0, 0, 0, 0.4)",
		500: "rgba(0, 0, 0, 0.5)",
		600: "rgba(0, 0, 0, 0.6)",
		700: "rgba(0, 0, 0, 0.7)",
		800: "rgba(0, 0, 0, 0.8)",
		900: "rgba(0, 0, 0, 0.9)",
		950: "rgba(0, 0, 0, 1.0)",
	},
	ZINC: {
		50: "#FAFAFA",
		100: "#F4F4F5",
		200: "#E4E4E7",
		300: "#D4D4D8",
		400: "#A1A1AA",
		500: "#71717A",
		600: "#52525B",
		700: "#3F3F46",
		800: "#27272A",
		900: "#18181B",
		950: "#09090B",
	},
	BLUE: {
		50: "#F0FAFF",
		100: "#E0F4FE",
		200: "#BAE6FD",
		300: "#7DD1FC",
		400: "#38B7F8",
		500: "#0E9FE9",
		600: "#0284C7",
		700: "#036BA1",
		800: "#075A85",
		900: "#0C4D6E",
		950: "#083349",
	},
	YELLOW: {
		50: "#FFFAF0",
		100: "#FFF4E0",
		200: "#FFEBB0",
		300: "#FFDD6F",
		400: "#FFD13A",
		500: "#FFC700",
		600: "#DBAB00",
		700: "#B28C00",
		800: "#8A6F00",
		900: "#735900",
		950: "#3D2F00",
	},
	GREEN: {
		50: "#F0FDF5",
		100: "#DCFCE8",
		200: "#BBF7D1",
		300: "#86EFAD",
		400: "#4ADE81",
		500: "#22C55E",
		600: "#16A34A",
		700: "#15803C",
		800: "#166533",
		900: "#14532B",
		950: "#052E14",
	},
	PURPLE: {
		50: "#FAF5FF",
		100: "#F3E8FF",
		200: "#E9D5FF",
		300: "#D9B4FE",
		400: "#C184FC",
		500: "#AA55F7",
		600: "#9533EA",
		700: "#8022CE",
		800: "#6C21A8",
		900: "#591C87",
		950: "#3C0764",
	},
	PINK: {
		50: "#FEF2F4",
		100: "#FDE6E9",
		200: "#FBD0D9",
		300: "#F7AAB9",
		400: "#F27A93",
		500: "#E63F66",
		600: "#D42A5B",
		700: "#B21E4B",
		800: "#951C45",
		900: "#801B40",
		950: "#470A1F",
	},
	SUCCESS: {
		50: "#F0FDF4",
		200: "#DCFCE7",
		400: "#86EFAC",
		600: "#16A34A",
	},
	ERROR: {
		50: "#FEF2F2",
		200: "#FEE2E2",
		400: "#FCA5A5",
		600: "#EF4444",
	},
	WARNING: {
		50: "#FEFCEA",
		200: "#FEF3C7",
		600: "#F59E0B",
	},
	LINK: {
		50: "#E6F6FF",
		200: "#DFEEFF",
		400: "#40AFFF",
		600: "#068EF1",
	},
	BG_LAYER: {
		50: "#FFFFF8",
		200: "#ECEDE5",
		400: "#F7F7F7",
		500: "#f8f8f8",
	},
	CAPTION: {
		50: "#8F8F8F",
	},
	// 旧管理画面の theme
	BEFORE: {
		"status-blue": "#0ea5e9",
	},
} as const satisfies { [key: string]: { [key: string]: string } };
